import React from "react";

interface SpacerProps {
  size?: number;
  direction?: "horizontal" | "vertical";
  className?: string;
}

export function Spacer(props: SpacerProps) {
  const { size, className, direction = "vertical" } = props;

  if (!size) {
    return <div style={{ flex: 1 }} />;
  }

  return (
    <div
      className={className}
      style={direction === "vertical" ? { height: size } : { width: size }}
    />
  );
}
